import { FileText } from "lucide-react";

export const Terms = () => {
  const lastUpdated = "April 25, 2026";

  return (
    <div className="min-h-screen pt-28 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-stone-50 to-white">
      <div className="max-w-3xl mx-auto" data-testid="terms-page">
        <div className="flex items-center gap-3 mb-2">
          <FileText className="h-8 w-8 text-emerald-600" />
          <h1 className="text-4xl font-bold text-gray-900">Terms of Service</h1>
        </div>
        <p className="text-sm text-gray-500 mb-10">Last updated: {lastUpdated}</p>

        <div className="prose prose-emerald max-w-none space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">1. Agreement</h2>
            <p>
              By placing an order with Raffy's Cuisine ("we", "us", or "our") through this website,
              you agree to these Terms of Service. If you do not agree, please do not use our
              service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">2. Ordering Window</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Orders may be placed Saturday 12:00 AM CT through Friday 11:59 PM CT each week.</li>
              <li>Orders submitted after the Friday 11:59 PM CT cutoff will be processed for the following week's delivery.</li>
              <li>All meals are delivered the Sunday following the cutoff (delivery window: 12:00 PM – 8:00 PM CT).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">3. Pricing, Tax & Fees</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>All prices are in U.S. dollars.</li>
              <li>Texas sales tax of 8.25% is added to all orders.</li>
              <li>Delivery fees: $5 within 5 miles of our base location, $10 for 5–30 miles. Delivery beyond 30 miles is not available online — please contact us directly.</li>
              <li>Optional gratuity is supported at checkout.</li>
              <li>We reserve the right to update menu prices at any time.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">4. Payment</h2>
            <p>
              Payments are processed securely by Square. We accept major credit and debit cards.
              Manual payment options (Zelle, CashApp) are also offered; orders paid by manual
              methods are confirmed only after payment is verified.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">5. Cancellation & Refund Policy</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Before the Friday 11:59 PM CT cutoff:</strong> orders may be cancelled or modified for a full refund. Email or call us to make changes.</li>
              <li><strong>After the cutoff:</strong> orders are in production and cannot be cancelled or refunded, since ingredients have already been purchased.</li>
              <li>If your order arrives damaged or incorrect, contact us within 24 hours of delivery and we will make it right (replacement, credit, or refund at our discretion).</li>
              <li>Refunds, when issued, are returned to the original payment method within 5–10 business days.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">6. Delivery</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>You are responsible for providing an accurate and accessible delivery address.</li>
              <li>If no one is available to receive the order, meals will be left at the door at the customer's risk.</li>
              <li>We are not liable for spoilage if meals are not refrigerated promptly after delivery.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">7. Food Safety & Allergens</h2>
            <p>
              Our meals are prepared in a kitchen that handles common allergens including dairy,
              eggs, gluten, soy, peanuts, tree nuts, fish, and shellfish. While we take reasonable
              precautions, we cannot guarantee meals are free from cross-contact. Customers with
              severe allergies should consult us before ordering. Meals should be refrigerated
              within 2 hours of delivery and consumed within 4 days for best quality.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">8. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials
              and for all activity under your account. Notify us immediately of any unauthorized
              use.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">9. Catering Orders</h2>
            <p>
              Catering inquiries submitted via our catering form are quote requests, not
              confirmed orders. Catering orders require a separate agreement and may have
              different lead-time and deposit requirements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Raffy's Cuisine's total liability for any
              claim arising from your use of our service is limited to the amount you paid for the
              order in question.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">11. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the State of Texas, without regard to its
              conflict-of-laws principles. Any dispute will be resolved in courts located in
              Tarrant County, Texas.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">12. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of the service after
              updates constitutes acceptance of the revised Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">13. Contact</h2>
            <ul className="list-none pl-0 space-y-1">
              <li><strong>Email:</strong> chefwegotittx@gmail.com</li>
              <li><strong>Phone:</strong> (682) 402-3734</li>
              <li><strong>Business:</strong> Raffy's Cuisine, Fort Worth, TX</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};
